export default "__VITE_ASSET__tLuHgvgz__"